import React, { useState } from 'react';
import { FiMap, FiList } from 'react-icons/fi';
import Map from '../components/Map';
import Timeline from '../components/Timeline';

// react-icons' IconType returns ReactNode, which React 19's JSX typing
// won't accept as a component; cast once here rather than at each call site.
const MapIcon = FiMap as unknown as React.FC<{ size?: number }>;
const ListIcon = FiList as unknown as React.FC<{ size?: number }>;

const pillStyle = (active: boolean): React.CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '8px 16px',
  borderRadius: '999px',
  border: 'none',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: '14px',
  fontFamily: 'inherit',
  background: active ? 'linear-gradient(90deg, #6366f1, #a855f7)' : 'transparent',
  color: active ? '#ffffff' : '#475569',
  transition: 'background 0.2s ease',
});

const Home: React.FC = () => {
  const [view, setView] = useState<'map' | 'timeline'>('map');

  return (
    <>
      <style>
        {`
          @keyframes auroraDrift1 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(60px, 40px) scale(1.15); }
          }
          @keyframes auroraDrift2 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(-50px, -30px) scale(1.1); }
          }
          @keyframes auroraDrift3 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(30px, -50px) scale(1.08); }
          }
        `}
      </style>

      <div
        style={{
          position: 'relative',
          minHeight: '100vh',
          overflow: 'hidden',
          background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #faf5ff 100%)',
          color: '#171616',
        }}
      >
        {/* Aurora background blobs */}
        <div
          style={{
            position: 'absolute',
            top: '-160px',
            left: '-120px',
            width: '520px',
            height: '520px',
            borderRadius: '50%',
            background: '#93c5fd',
            filter: 'blur(120px)',
            opacity: 0.4,
            animation: 'auroraDrift1 24s ease-in-out infinite',
            pointerEvents: 'none',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '-180px',
            right: '-100px',
            width: '480px',
            height: '480px',
            borderRadius: '50%',
            background: '#c4b5fd',
            filter: 'blur(120px)',
            opacity: 0.35,
            animation: 'auroraDrift2 28s ease-in-out infinite',
            pointerEvents: 'none',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '25%',
            right: '15%',
            width: '360px',
            height: '360px',
            borderRadius: '50%',
            background: '#67e8f9',
            filter: 'blur(110px)',
            opacity: 0.25,
            animation: 'auroraDrift3 32s ease-in-out infinite',
            pointerEvents: 'none',
          }}
        />

        <div style={{ position: 'relative', zIndex: 1, padding: '20px 20px', boxSizing: 'border-box' }}>
        <h1
          style={{
            margin: '0 0 6px 10px',
            fontSize: 'clamp(28px, 5vw, 44px)',
            fontWeight: 800,
            letterSpacing: '-0.5px',
          }}
        >
          <span style={{ color: '#171616' }}>2025 Adventures</span>
        </h1>
        <p
          style={{
            margin: '0 0 24px 10px',
            fontSize: 'clamp(13px, 1.6vw, 15px)',
            color: '#64748b',
          }}
        >
          An unforgettable 12-week trip to South East Asia, featuring Indonesia, Malaysia, Vietnam &amp; Thailand.
        </p>

        <div
          style={{
            display: 'flex',
            gap: '4px',
            background: 'rgba(15,23,42,0.04)',
            padding: '4px',
            borderRadius: '999px',
            width: 'fit-content',
            marginBottom: '16px',
            marginLeft: '10px',
            border: '1px solid rgba(15,23,42,0.08)',
          }}
        >
          <button onClick={() => setView('map')} style={pillStyle(view === 'map')}>
            <MapIcon size={16} /> Map
          </button>
          <button onClick={() => setView('timeline')} style={pillStyle(view === 'timeline')}>
            <ListIcon size={16} /> Timeline
          </button>
        </div>

        <div
          style={{
            background: 'rgba(255,255,255,0.6)',
            borderRadius: '18px',
            padding: '20px',
            backdropFilter: 'blur(16px)',
            boxShadow: '0 12px 30px rgba(15, 23, 42, 0.08)',
            border: '1px solid rgba(15,23,42,0.06)',
          }}
        >
          {view === 'map' ? <Map /> : <Timeline />}
        </div>
        </div>
      </div>
    </>
  );
};

export default Home;
